export const SELECT_FILLER = "SELECT_FILLER";
export const ADD_FILLER = "ADD_FILLER";
export const RM_FILLER = "RM_FILLER";
export const ATTACH_FILLER = "ATTACH_FILLER";
export const ATTACH_FILLERS = "ATTACH_FILLERS";
export const DETACH_FILLER = "DETACH_FILLER";
export const SET_BANK_HOLIDAY_DATES = "SET_BANK_HOLIDAY_DATES";
export const SET_NON_WORKING_DATES = "SET_NON_WORKING_DATES";
export const CHANGE_FILLER = "CHANGE_FILLER";
export const SET_PERIOD = "SET_PERIOD";


/** WEBPACK FOOTER **
 ** ./web/static/js/action_types.js
 **/